<template>
  <div>
    <div style="border: 1px solid #ccc; margin-top: 10px;">
      <!-- 工具栏 -->
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        ref="toolbar"
      />
      <!-- 编辑器 -->
      <Editor
        ref="editor"
        style="height: 400px; "
        :defaultConfig="editorConfig"
        v-model="html"
        @onChange="onChange"
        @onCreated="onCreated"
        @customPaste="customPaste"
        @onBlur="$emit('blur')"
      />
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { upload_media, upload_multi_images } from "@/api/media";
import { i18nGetResources, i18nChangeLanguage,i18nAddResources } from "@wangeditor/editor";

import _ from "lodash";
import moment from "moment";

export default {
  name: "MyEditor",
  components: { Editor, Toolbar },
  props: {
    value: {
      default: ""
    },
    /**
     * 数组接受两种类型的元素
     * Object: {key: xxx, index: xxx}
     * String: "xxx"
     */
    toolbarKeys: {
      type: Array,
      default: () => []
    },
    excludeKeys: {
      type: Array,
      default: () => []
    },
    clearToolbarKeys: {
      type: Boolean,
      default: false
    },
    upload_image_from: {
      type: String,
      default: "document"
    }
  },
  data() {
    return {
      editor: null,
      html: "",
      need_auth: ["notice"],
      default_toolbarKeys: [
        "undo",
        "redo",
        "headerSelect",
        "bold",
        "underline",
        "italic",
        "color",
        "bgColor",
        {
          key: "group-justify", // 必填，要以 group 开头
          title: "", // 必填
          iconSvg:
            '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>',
          menuKeys: [
            "justifyLeft",
            "justifyRight",
            "justifyCenter",
            "justifyJustify"
          ]
        },
        "fontFamily",
        "fontSize",
        "insertLink",
        "uploadImage",
        "fullScreen"
      ],
      default_excludeKeys: [
        "blockquote",
        "lineHeight",
        "bulletedList",
        "numberedList",
        "group-indent",
        "group-more-style",
        "group-video",
        "divider",
        "indent",
        "codeBlock",
        "todo",
        "insertVideo",
        "uploadVideo",
        "emotion",
        "insertTable"
      ],
      editorConfig: {
        placeholder: "",
 
        // autoFocus: false,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            // 自定义上传
            customUpload: (file, insertFn) => {
              // console.log(file,"上传的file")
              let formData = new FormData();
              formData.append("file", file);

              upload_media(
                {
                  from: this.upload_image_from
                },
                formData
              ).then(res => {
                // successCb(res);
                insertFn(
                  this.need_auth.includes(this.upload_image_from)
                    ? res.body.image_path
                    : res.body.media.media_url,
                  file.name,
                  this.need_auth.includes(this.upload_image_from)
                    ? res.body.image_path
                    : res.body.media.media_url
                );
                this.$emit("upload_image", res.body);
              });
            }
          }
        }
      }
    };
  },
  watch: {
    clearToolbarKeys(newVal) {
      if (newVal === true) {
        this.default_toolbarKeys.forEach(item => {
          if (item instanceof Object) {
            this.excludeKeys.push(item.key);
          } else {
            this.excludeKeys.push(item);
          }
        });
      }
    },
    value(newVal){
      this.setValue(newVal)
    },
  },
  computed: {
    toolbarConfig() {
      return {
        toolbarKeys: this.custom_toolbarKeys,
        excludeKeys: this.custom_excludeKeys
      };
    },
    custom_toolbarKeys() {
      const keys = _.cloneDeep(this.default_toolbarKeys);
      this.toolbarKeys.forEach((item, index) => {
        if (item instanceof Object) {
          // 如果要添加的key在default_excludeKeys数组中， 就把该key从default_excludeKeys数组中删除
          this.delete_excludeKey(item.key);
          // 如果没传index, 则直接在后面添加
          if (item.index) {
            keys.split(item.index, 0, item.key);
          } else {
            keys.push(item);
          }
        }
        if (typeof item == "string") {
          // 如果要添加的key在default_excludeKeys数组中， 就把该key从default_excludeKeys数组中删除
          this.delete_excludeKey(item);
          this.keys.push(item);
        } else {
          console.error(
            `类型错误: 当前第${index}个元素类型是${typeof item}，传入的类型只能是对象或字符串`
          );
        }
      });
      return keys;
    },
    custom_excludeKeys() {
      return [...this.default_excludeKeys, ...this.excludeKeys];
    }
  },
  methods: {
    getElemsByType(type) {
      this.$refs.editor.getElemsByType(type);
    },
    delete_excludeKey(key) {
      const exclude_index = this.default_excludeKeys.findIndex(
        exKey => exKey === key
      );
      if (exclude_index >= 0) {
        this.default_excludeKeys.split(exclude_index, 1);
      }
    },
    customPaste(editor, event) {
      // console.log(event, "我是粘贴事件");
      let html = event.clipboardData.getData("text/html");
      // 获取rtf数据（从word、wps复制粘贴时有），复制粘贴过程中图片的数据就保存在rtf中
      const rtf = event.clipboardData.getData("text/rtf");
      if (html && rtf) {
        // 该条件分支即表示要自定义word粘贴
        // 列表缩进会超出边框，直接过滤掉
        html = html.replace(/text\-indent:\-(.*?)pt/gi, ""); //清除缩进
        html = html.replace(/font\-family:(.*?)/gi, ""); //清楚粘贴过来的字体样式
        // 从html内容中查找粘贴内容中是否有图片元素，并返回img标签的属性src值的集合
        const imgSrcs = this.findAllImgSrcsFromHtml(html);
        // console.log(imgSrcs, "imgSrcsimgSrcsimgSrcsimgSrcs");
        // 如果有
        if (imgSrcs && Array.isArray(imgSrcs) && imgSrcs.length) {
          // 从rtf内容中查找图片数据
          const rtfImageData = this.extractImageDataFromRtf(rtf);
          // console.log(rtfImageData, "rtfImageDatartfImageDatartfImageData");
          // 如果找到
          if (rtfImageData.length) {
            // TODO：此处可以将图片上传到自己的服务器上
            const resList = rtfImageData.map(item => {
              let formData = new FormData();
              const file = this.blobToFile(
                this.dataURLtoBlob(
                  `data:${item.type};base64,${this._convertHexToBase64(
                    item.hex
                  )}`
                )
              );
              formData.append("file", file);
              return upload_media(
                {
                  from: this.upload_image_from
                },
                formData
              );
            });
            Promise.all(resList).then(res => {
              // console.log(res, "resresresresresresres");
              let newImgSrcs = res.map(item => {
                this.$emit("upload_image", item);
                return this.need_auth.includes(this.upload_image_from)
                  ? item.body.image_path
                  : item.body.media.media_url;
              });
              // 执行替换：将html内容中的img标签的src替换成ref中的图片数据，如果上面上传了则为图片路径
              html = this.replaceImagesFileSourceWithInlineRepresentation(
                html,
                imgSrcs,
                newImgSrcs
              );
              this.editor.dangerouslyInsertHtml(html);
            });
          }
        } else {
          this.editor.dangerouslyInsertHtml(html);
        }
        event.preventDefault();
        return false;
      } else {
        return true;
      }
    },
    onCreated(editor) {
      this.setValue(this.value);
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },
    onChange(editor) {
      this.$emit(
        "update:value",
        editor.getHtml().replace(/font\-family: (.*?);/gi, "")
      );
    },

    disableHandler() {
      const editor = this.editor;
      if (editor == null) return;
      editor.disable();
    },
    destroy() {
      const editor = this.editor;
      if (editor == null) return;
      editor.destroy(); // 组件销毁时，及时销毁 editor ，重要！！！
    },
    setValue(value) {
      this.html = value;
      // console.log(value, "this.documentData.contentthis.documentData.content")
    },
    // 自定义粘贴的工具函数
    /**
     * 从html代码中匹配返回图片标签img的属性src的值的集合
     * @param htmlData
     * @return Array
     */
    findAllImgSrcsFromHtml(htmlData) {
      let imgReg = /<img.*?(?:>|\/>)/gi; //匹配图片中的img标签
      let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
      let arr = htmlData.match(imgReg); //筛选出所有的img
      if (!arr || (Array.isArray(arr) && !arr.length)) {
        return false;
      }
      let srcArr = [];
      for (let i = 0; i < arr.length; i++) {
        let src = arr[i].match(srcReg);
        // 获取图片地址
        srcArr.push(src[1]);
      }
      return srcArr;
    },
    /**
     * 从rtf内容中匹配返回图片数据的集合
     * @param rtfData
     * @return Array
     */
    extractImageDataFromRtf(rtfData) {
      if (!rtfData) {
        return [];
      }
      const regexPictureHeader = /{\\pict[\s\S]+?({\\\*\\blipuid\s?[\da-fA-F]+)[\s}]*/;
      const regexPicture = new RegExp(
        "(?:(" + regexPictureHeader.source + "))([\\da-fA-F\\s]+)\\}",
        "g"
      );
      const images = rtfData.match(regexPicture);
      const result = [];
      if (images) {
        for (const image of images) {
          let imageType = false;
          if (image.includes("\\pngblip")) {
            imageType = "image/png";
          } else if (image.includes("\\jpegblip")) {
            imageType = "image/jpeg";
          }
          if (imageType) {
            result.push({
              hex: image
                .replace(regexPictureHeader, "")
                .replace(/[^\da-fA-F]/g, ""),
              type: imageType
            });
          }
        }
      }
      return result;
    },
    /**
     * 将html内容中img标签的属性值替换
     * @param htmlData html内容
     * @param imageSrcs html中img的属性src的值的集合
     * @param imagesHexSources rtf中图片数据的集合，与html内容中的img标签对应
     * @param isBase64Data 是否是Base64的图片数据
     * @return String
     */
    replaceImagesFileSourceWithInlineRepresentation(
      htmlData,
      imageSrcs,
      imagesHexSources
      // isBase64Data = true
    ) {
      if (imageSrcs.length === imagesHexSources.length) {
        for (let i = 0; i < imageSrcs.length; i++) {
          // const newSrc = isBase64Data
          //   ? `data:${
          //       imagesHexSources[i].type
          //     };base64,${this._convertHexToBase64(imagesHexSources[i].hex)}`
          //   : imagesHexSources[i];
          const newSrc = imagesHexSources[i];
          htmlData = htmlData.replace(imageSrcs[i], newSrc);
        }
      }
      return htmlData;
    },
    /**
     * 十六进制转base64
     */
    _convertHexToBase64(hexString) {
      return btoa(
        hexString
          .match(/\w{2}/g)
          .map(char => {
            return String.fromCharCode(parseInt(char, 16));
          })
          .join("")
      );
    },
    // 将base64转换为blob
    dataURLtoBlob(dataURI) {
      var mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0]; // mime类型
      var byteString = atob(dataURI.split(",")[1]); //base64 解码
      var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
      var intArray = new Uint8Array(arrayBuffer); //创建视图

      for (var i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
      }
      return new Blob([intArray], { type: mimeString });
    },
    // 将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = `${moment().format("x")}.${theBlob.type.slice(6)}`;
      // console.log(theBlob, "theBlobtheBlobtheBlobtheBlob");
      return new File(
        [theBlob],
        theBlob.name, //名字
        { type: theBlob.type }
      );
    }
  },

  mounted() {
    i18nAddResources("zh-TW", {
      common: { ok: "確定", delete: "刪除", enter: "回車" },
      blockQuote: { title: "引用" },
      codeBlock: { title: "代碼塊" },
      color: {
        color: "文字顏色",
        bgColor: "背景色",
        default: "默認顏色",
        clear: "清除背景色"
      },
      divider: { title: "分割線" },
      emotion: { title: "表情" },
      fontSize: { title: "字號", default: "默認字號" },
      fontFamily: { title: "字體", default: "默認字體" },
      fullScreen: { title: "全屏" },
      header: { title: "標題", text: "正文" },
      image: {
        netImage: "網絡圖片",
        delete: "刪除圖片",
        edit: "編輯圖片",
        viewLink: "查看鏈接",
        src: "圖片地址",
        desc: "圖片描述",
        link: "圖片鏈接"
      },
      indent: { decrease: "減少縮進", increase: "增加縮進" },
      justify: {
        left: "左對齊",
        right: "右對齊",
        center: "居中對齊",
        justify: "兩端對齊"
      },
      lineHeight: { title: "行高", default: "默認行高" },
      link: {
        insert: "插入鏈接",
        text: "鏈接文本",
        url: "鏈接地址",
        unLink: "取消鏈接",
        edit: "修改鏈接",
        view: "查看鏈接"
      },
      textStyle: {
        bold: "粗體",
        clear: "清除格式",
        code: "行內代碼",
        italic: "斜體",
        sub: "下標",
        sup: "上標",
        through: "刪除線",
        underline: "下劃線"
      },
      undo: { undo: "撤銷", redo: "重做" },
      todo: { todo: "待辦" }
    });
    // 模拟 ajax 请求，异步渲染编辑器
    // setTimeout(() => {
    i18nChangeLanguage(this.$store.getters.get_current_language);
    // }, 1500);
  },
  beforeDestroy() {
    this.destroy(); // 组件销毁时，及时销毁 editor ，重要！！！
  }
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
/deep/ .w-e-scroll {
  // p{
  //   margin-top: 0px !important;
  // }
  // p:first-of-type{
  //   margin-top: 5px;
  // }

  // br{
  //   margin: 5px 0;
  // }
}
/deep/ .w-e-full-screen-container {
  z-index: 99;
}
/deep/ .w-e-bar-divider {
  display: none;
}

/deep/ .button-container button {
  line-height: 21px;
}
</style>



// WEBPACK FOOTER //
// src/components/my_editor.vue